import styles from './expired-license-grid.module.scss';
import { useTableConfigHook } from '../../requestUtils';
import { booleanHeader, CreateHeaders, dateHeader, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { IExpiredLicenses } from '../../_models/expired-licenses';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ExpiredLicenseGridProps {
  expiredLicenses: IExpiredLicenses[],
  onDateChange: (dateRange: DateRange<Date> | null) => void,
  dateRange: DateRange<Date>,
  forGroup: boolean,
  onForGroupToggle: () => void,
  onRefresh: () => void,
  isLoading: boolean
}

export function ExpiredLicenseGrid(props: ExpiredLicenseGridProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("expiredLicenses");

  return (
    <WebkuaTable
      onRefresh={props.onRefresh}
      isLoading={props.isLoading}
      headers={CreateHeaders([
        textHeader("companyName", t("standard.company"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
        textHeader("product", t("standard.product"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
        booleanHeader("isSlm", "SLM"),
        booleanHeader("isSubscription", t("expiredLicense.subscription")),
        booleanHeader("isMaintained", t("expiredLicense.maintenance")),
        dateHeader("maintenanceEndDate", t("standard.expirationDate")),
        dateHeader("expirationDate", t("standard.expiryDate"))
      ])}
      tableFilters={[
        {
          label: t("standard.showForGroup"),
          checked: props.forGroup,
          onChange: props.onForGroupToggle
        }
      ]}
      data={props.expiredLicenses}
      tableConfig={tableConfig}
      onSetDateRange={props.onDateChange}
      dateRange={props.dateRange}
    />
  );
}

export default ExpiredLicenseGrid;